import { IModuleProps } from '../../core/utils/modules';

import locales from './locales';

export default {
    name: 'kluthe',
    locales,
} as IModuleProps;
